import { render, staticRenderFns } from "./JobComplianceModal.vue?vue&type=template&id=2bf3a5a1&scoped=true"
import script from "./JobComplianceModal.vue?vue&type=script&lang=ts"
export * from "./JobComplianceModal.vue?vue&type=script&lang=ts"
import style0 from "./JobComplianceModal.vue?vue&type=style&index=0&id=2bf3a5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3a5a1",
  null
  
)

export default component.exports